module.exports = __webpack_public_path__ + "326c1e67a92cd975df025259e3b900d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/ghost.png
// module id = 1847
// module chunks = 0